; (function () {
  const ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
  const TOKEN_LENGTH = 24

  const employeeInviteToken = initialToken => {
    return {
      token: initialToken || '',

      generate: function () {
        const bytes = new Uint8Array(TOKEN_LENGTH)

        window.crypto.getRandomValues(bytes)

        this.token = Array.from(bytes, byte => ALPHABET[byte % ALPHABET.length]).join('')
      }
    }
  }

  if (typeof window !== 'undefined') {
    window.employeeInviteToken = employeeInviteToken
  }
  return employeeInviteToken
})()
